import { Navigate, useLocation } from 'react-router-dom';
import { keycloak } from '../auth/keycloak';
import LayoutRoot from '../pages/LayoutRoot';
import StudentParentLandingPage from '../pages/marketing/StudentParentLandingPage';
import { RequireAuth } from './RouteGuards';

/** `/` = marketing khi chưa login; còn lại = app có auth như trước. */
export function AppRootLayout(): JSX.Element {
  const { pathname } = useLocation();
  const isAuthenticated = Boolean(keycloak?.authenticated);

  if (pathname === '/' && !isAuthenticated) {
    return <StudentParentLandingPage />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <RequireAuth>
      <LayoutRoot />
    </RequireAuth>
  );
}
